<template>
  <el-dialog :visible="AboutShow" @close="btnrest" width="980px" top="10%" class="scroll-box3" :close-on-click-modal="false">
    <div class="about_box">
      <div class="about_top">
        <div class="logo_text">
          <h2>华e学车云平台</h2>
          <p>版本号：V1.0.0.0</p>
        </div>
      </div>
      <div class="about_label">关于系统介绍</div>
      <div class="about_content">
        <div class="about_js">
          <p><strong>软件简介：</strong>该系统可以提高驾校的信息化程度</p>
        </div>
        <div class="about_Tel">
          <strong>客服热线：</strong>
          <a href="tel:xxx"></a>
        </div>
        <div class="about_http">
          <strong>官方网址：</strong>
          <a href="https://www.xxx.com"></a>
        </div>
        <div class="about_copyright">
          <strong>版权所有：</strong>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["AboutShow"],
  methods: {
    btnrest: function() {
      this.$emit("AboutShow", true);
    },
    allclose: function() {
      this.innerVisible = false;
      this.$emit("AboutShow", true);
    },
  },
};
</script>
<style scoped>
.scroll-box3 >>> .el-dialog__body {
  padding: 0;
  margin-top: -54px;
  height: 600px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/child/abouts.vue